// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"91":"495a020382724eb0","279":"f54d22a7a43e3e4b"}[chunkId] + ".js";
};